import { Pipe, PipeTransform } from '@angular/core';
import { Offer } from '../../core/models/offer/offer.model';
import { TailsPricePipe } from './tails-price.pipe';

@Pipe({
  name: 'offerTailsPrice'
})
export class OfferTailsPricePipe extends TailsPricePipe implements PipeTransform {

  transform(value: any | Offer, selectedPremium?: string): any {
    return value.hasOwnProperty('premiums') ? super.transform(Offer.getOfferPrice(value, selectedPremium)) : super.transform(value);
  }
}
